import { Fragment, type ReactNode } from 'react';
import { Plus } from '@doist/icons/product-ui';
import { Button, Divider, Text } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import css from './product-ui-sub-tasks-section.module.css';
type ProductUISubTasksSectionProps = {
  subtasks?: ReactNode[];
  addSubtaskButton?: ReactNode;
};
function ProductUISubTasksSection({
  subtasks,
  addSubtaskButton
}: ProductUISubTasksSectionProps) {
  const {
    t
  } = useTranslation('productui');
  return <div className={css.container} data-sentry-component="ProductUISubTasksSection" data-sentry-source-file="product-ui-sub-tasks-section.tsx">
            {subtasks ? <>
                    <div className={css.header}>
                        <div className={css.left}>
                            <Text size="minor-xs" weight="medium" tag="span">
                                {t('subtasks')}
                            </Text>
                            <ProductUISkeletonText width="100" />
                        </div>

                        <Button size="xsmall" tag="span" variant="quinary">
                            {t('showCompleted')}
                        </Button>
                    </div>
                    <div className={css.subTasks}>
                        <Divider />
                        {subtasks.map((task: ReactNode, idx: number) => <Fragment key={idx}>
                                {task}
                                <Divider />
                            </Fragment>)}
                    </div>
                </> : <>{addSubtaskButton}</>}
        </div>;
}
ProductUISubTasksSection.AddButton = ({
  children
}: {
  children: ReactNode;
}) => {
  return <>
            <Button startIcon={Plus} size="xsmall" tag="span" variant="quinary">
                {children}
            </Button>
            <Divider style={{
      marginBlockStart: 'var(--space-16)'
    }} />
        </>;
};
export { ProductUISubTasksSection };